import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CountdownTimer.css';

const CountdownTimer = ({ targetDate, onExpired }) => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    const target = new Date(targetDate).getTime();

    // Verificar estado inicial
    const checkInitial = () => {
      const now = new Date().getTime();
      const difference = target - now;
      if (difference <= 0) {
        setIsExpired(true);
        if (onExpired) {
          onExpired(true);
        }
        return true;
      }
      return false;
    };

    if (checkInitial()) {
      return; // Si ya expiró, no iniciar el intervalo
    }

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const difference = target - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000)
        });
      } else {
        setIsExpired(true);
        if (onExpired) {
          onExpired(true);
        }
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate, onExpired]);

  if (isExpired) {
    return (
      <div className="countdown-container countdown-expired">
        <div className="countdown-expired-message">
          {t('countdown.expired')}
        </div>
      </div>
    );
  }

  return (
    <div className="countdown-container">
      <div className="countdown-items">
        <div className="countdown-item">
          <span className="countdown-value">{timeLeft.days}</span>
          <span className="countdown-label">{t('time.days')}</span>
        </div>
        <div className="countdown-item">
          <span className="countdown-value">{timeLeft.hours}</span>
          <span className="countdown-label">{t('time.hours')}</span>
        </div>
        <div className="countdown-item">
          <span className="countdown-value">{timeLeft.minutes}</span>
          <span className="countdown-label">{t('time.minutes')}</span>
        </div>
        <div className="countdown-item">
          <span className="countdown-value">{timeLeft.seconds}</span>
          <span className="countdown-label">{t('time.seconds')}</span>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer; 